const GameplayStyle = {
    GET_TO_THE_EXIT: 0,
    FILL_HOLES_WITH_CRATES: 1,
    COLLECT_ALL_COINS: 2
}

export default GameplayStyle;

export function getGameplayStyleFromKey(key) {
    return Object.keys(GameplayStyle).find(k => GameplayStyle[k] === key);
}